<template>
    <div>
        <div class="qa-area-q py-1 px-pc-2 px-sp-4">
            <h3 class="d-flex">
                <div class="mr-2">Q{{num}}.</div>
                <div>
                    <slot name="q"></slot>
                </div>
            </h3>
        </div>
        <div class="mt-2 text-left px-sp-4">
            <slot name="a"></slot>
        </div>
    </div>
</template>
<script>
export default {
    props:["num"]
}
</script>